import { IBlock } from "../../../../../framework/src/IBlock";
import { Message } from "../../../../../framework/src/Message";
import { BlockComponent } from "../../../../../framework/src/BlockComponent";
import MessageEnum, {
  getName
} from "../../../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../../../framework/src/RunEngine";

// Customizable Area Start
import StorageProvider from "../../../../../framework/src/StorageProvider";
// Customizable Area End

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  surgeonsData: any;
  searchData:any;
  query: string
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class ValidateNewSurgeonController extends BlockComponent<Props, S, SS> {
  apiContactPriorityId: any;
  apigetValidateSurgeonId: any;
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.state = {
      surgeonsData: null,
      query: '',
      searchData: null,
    };

    // Customizable Area Startg
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
   if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      this.apigetValidateSurgeonId !== null &&
      this.apigetValidateSurgeonId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      this.apigetValidateSurgeonId = null;
      var responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      var errorReponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );
      if (responseJson && responseJson.data) {
        this.getValidateSurgeonSuccess(responseJson.data);
      } else {
        //Check Error Response
        this.getValidateSurgeonFail();
        this.parseApiErrorResponse(responseJson);
      }
      this.parseApiCatchErrorResponse(errorReponse);
    }
    // Customizable Area End
  }

  // Customizable Area Start
  handleSearch = (text : any) => {
    this.setState({query:text})
     if(text !== "") {
           const newData = this.state.surgeonsData.filter((name: any) => {
           return Object.values(name.attributes)
                 .join(" ")
                 .toLowerCase()
                 .includes(text.toLowerCase());
           });
           this.setState({searchData:newData});
           console.log(newData);

     } else {
       this.setState({searchData:this.state.surgeonsData});
     }
   };

  async componentDidMount() {
    if( window.screen.width < 950){
    super.componentDidMount();
    this.getValidateSurgeon();
    }
  }
  getValidateSurgeon = async () => {
    const header = {
      "Content-Type": "application/json",
      token: localStorage.getItem("authToken")
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.apigetValidateSurgeonId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      "bx_block_material_manager/material_manager/pending_surgeons"
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);

    return true;
  };
  getValidateSurgeonSuccess = (data: any) => {
    this.setState({ surgeonsData: data });
  };

  getValidateSurgeonFail = () => {};

  // Customizable Area End
}
